import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@material-ui/core/'
import { LineChart, Line, CartesianGrid, Label, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
import moment from 'moment'
import { DateRangePicker, AutocompleteCity } from 'components/UI'
import apiAdmin from '../../../../../../../api/admin'
import peoplesIcon from '../../../../../../../assetss/img/peoplesIcon.svg'
import calendarIcon from '../../../../../../../assetss/img/calendarIcon.svg'
import listIcon from '../../../../../../../assetss/img/listIcon.svg'
import peopleIcon from '../../../../../../../assetss/img/peopleIcon.svg'
import './index.scss'

const itemsInformations = [
  { img: peoplesIcon, count: 1234, title: 'Users amount', name: 'users' },
  { img: calendarIcon, count: 1234, title: 'Meeting amount', name: 'meetings' },
  { img: listIcon, count: 1234, title: 'Stories amount', name: 'stories' },
  { img: peopleIcon, count: 1234, title: 'Clients' },
  { img: peopleIcon, count: 1234, title: 'Clients' },
  { img: peopleIcon, count: 1234, title: 'Reported users', name: 'reports' },
]

const CustomTooltip = ({ active, payload }) => {
  if (active) {
    return (
      <div className='customTooltip'>
        <span className='toolTipDate'>
          {payload?.[0]?.value}
        </span>
        <span>
          {moment(payload?.[0]?.payload?.date)?.endOf('day').format('l')}
        </span>
      </div>
    )
  }

  return null
}

const All = () => {
  const { user } = useSelector(({ session }) => session)
  const [fullStatisrics, setFullStatictics] = useState({})
  const [userInfo, setUserInfo] = useState([])
  const [storyInfo, setStoryInfo] = useState([])
  const [reportInfo, setReportInfo] = useState([])
  const [meetingInfo, setMeetingInfo] = useState([])
  const [towns, setTowns] = useState([])
  const [serchTown, setSearchTown] = useState('')
  const [value, setValue] = useState([
    {
      startDate: new Date(moment(new Date())?.startOf('month')),
      endDate: new Date(moment(new Date())?.endOf('month')),
      key: 'selection',
    },
  ])

  const getTowns = () => {
    apiAdmin?.getTowns(user?.accessKey)
      .then(({ data }) => setTowns(data?.towns))
      .catch(error => console.error(error))
  }

  const getStatisticUsers = () => {
    apiAdmin?.getStatisticsGraphik(user?.accessKey, 'users', {
      dateFrom: moment(new Date(value?.[0]?.startDate))?.startOf('day')?.toISOString(),
      dateTo: moment(new Date(value?.[0]?.endDate))?.endOf('day')?.toISOString(),
    }, serchTown)
      .then(({ data }) => setUserInfo([...data?.statistics]))
      .catch(error => console.error(error))
  }

  const getStatisticMeetings = () => {
    apiAdmin?.getStatisticsGraphik(user?.accessKey, 'meetings', {
      dateFrom: moment(new Date(value?.[0]?.startDate))?.startOf('day')?.toISOString(),
      dateTo: moment(new Date(value?.[0]?.endDate))?.endOf('day')?.toISOString(),
    }, serchTown)
      .then(({ data }) => setMeetingInfo([...data?.statistics]))
      .catch(error => console.error(error))
  }

  const getStatisticStories = () => {
    apiAdmin?.getStatisticsGraphik(user?.accessKey, 'stories', {
      dateFrom: moment(new Date(value?.[0]?.startDate))?.startOf('day')?.toISOString(),
      dateTo: moment(new Date(value?.[0]?.endDate))?.endOf('day')?.toISOString(),
    }, serchTown)
      .then(({ data }) => setStoryInfo([...data?.statistics]))
      .catch(error => console.error(error))
  }

  const getStatisticReports = () => {
    apiAdmin?.getStatisticsGraphik(user?.accessKey, 'reports', {
      dateFrom: moment(new Date(value?.[0]?.startDate))?.startOf('day')?.toISOString(),
      dateTo: moment(new Date(value?.[0]?.endDate))?.endOf('day')?.toISOString(),
    }, serchTown)
      .then(({ data }) => setReportInfo([...data?.statistics]))
      .catch(error => console.error(error))
  }

  const getStatisticsFull = () => {
    apiAdmin?.getStatistics(user?.accessKey, {
      dateFrom: moment(new Date(value?.[0]?.startDate))?.startOf('day')?.toISOString(),
      dateTo: moment(new Date(value?.[0]?.endDate))?.endOf('day')?.toISOString(),
    }, serchTown)
      .then(({ data }) => setFullStatictics(data?.summary))
  }

  useEffect(() => {
    getStatisticsFull()
    getStatisticUsers()
    getStatisticMeetings()
    getStatisticStories()
    getStatisticReports()
  }, [value])

  useEffect(() => {
    getStatisticsFull()
    getStatisticUsers()
    getStatisticMeetings()
    getStatisticStories()
    getStatisticReports()
  }, [serchTown])

  useEffect(() => {
    getTowns()
  }, [])

  const filterStatictiks = name => {
    if (name === 'users') {
      return fullStatisrics?.users
    } else if (name === 'meetings') {
      return fullStatisrics?.meetings
    } else if (name === 'stories') {
      return fullStatisrics?.stories
    } else if (name === 'reports') {
      return fullStatisrics?.reports
    } else {
      return 0
    }
  }

  return (
    <Grid className='wrapperAdminAll'>
      <Grid className='blockInfoUsers'>
        <Grid className='blockInfoItems'>
          {itemsInformations?.map(({ img, count, title, name }) => (
            <Grid className='cardInfo' key={title}>
              <img className='imgInfo' src={img} />
              <Grid className='countCard'>
                {filterStatictiks(name)}
              </Grid>
              <Grid className='cardTitle'>{title}</Grid>
            </Grid>
          ))}
        </Grid>
        <Grid className='usersInfoGraphic'>
          <Grid className='boxTitleTable'>
            <Grid className='leftTitleTable'>
              <Grid className='nameTable'>Users</Grid>
            </Grid>
            <Grid className='countTable'>Total: {fullStatisrics?.users}</Grid>
          </Grid>
          <ResponsiveContainer width='100%' height='75%'>
            <LineChart width={200} height={100} data={userInfo}>
              <CartesianGrid vertical={false} />
              <Line stroke='#2196F3' dataKey='count' type='monotone' strokeWidth={2} />
              <Tooltip content={<CustomTooltip />} />
              <Label value='any' />
              <YAxis domain={[0, 40]} axisLine={false} orientation='right' />
            </LineChart>
          </ResponsiveContainer>
          <Grid className='dateTable'>
            <Grid className='dateStyle'>
              {value?.[0]?.startDate ? moment(value?.[0]?.startDate)?.format('D MMMM') : moment()?.format('D MMMM')}
            </Grid>
            <Grid className='dateStyle'>
              {value?.[0]?.endDate ? moment(value?.[0]?.endDate)?.format('D MMMM') : moment()?.format('D MMMM')}
            </Grid>
          </Grid>
        </Grid>
        <Grid className='usersInfoGraphic'>
          <Grid className='boxTitleTable'>
            <Grid className='leftTitleTable'>
              <Grid className='nameTable'>Meetings</Grid>
            </Grid>
            <Grid className='countTable'>Total: {fullStatisrics?.meetings}</Grid>
          </Grid>
          <ResponsiveContainer width='100%' height='75%'>
            <LineChart width={200} height={100} data={meetingInfo}>
              <CartesianGrid vertical={false} />
              <Line stroke='#2196F3' dataKey='createdCount' type='monotone' strokeWidth={2} />
              <Tooltip content={<CustomTooltip />} />
              <Label value='any' />
              <YAxis domain={[0, 40]} axisLine={false} orientation='right' />
            </LineChart>
          </ResponsiveContainer>
          <Grid className='dateTable'>
            <Grid className='dateStyle'>
              {value?.[0]?.startDate ? moment(value?.[0]?.startDate)?.format('D MMMM') : moment()?.format('D MMMM')}
            </Grid>
            <Grid className='dateStyle'>
              {value?.[0]?.endDate ? moment(value?.[0]?.endDate)?.format('D MMMM') : moment()?.format('D MMMM')}
            </Grid>
          </Grid>
        </Grid>
        <Grid className='usersInfoGraphic'>
          <Grid className='boxTitleTable'>
            <Grid className='leftTitleTable'>
              <Grid className='nameTable'>Stories</Grid>
            </Grid>
            <Grid className='countTable'>Total: {fullStatisrics?.stories}</Grid>
          </Grid>
          <ResponsiveContainer width='100%' height='75%'>
            <LineChart width={200} height={100} data={storyInfo}>
              <CartesianGrid vertical={false} />
              <Line stroke='#2196F3' dataKey='count' type='monotone' strokeWidth={2} />
              <Tooltip content={<CustomTooltip />} />
              <Label value='any' />
              <YAxis domain={[0, 40]} axisLine={false} orientation='right' />
            </LineChart>
          </ResponsiveContainer>
          <Grid className='dateTable'>
            <Grid className='dateStyle'>
              {value?.[0]?.startDate ? moment(value?.[0]?.startDate)?.format('D MMMM') : moment()?.format('D MMMM')}
            </Grid>
            <Grid className='dateStyle'>
              {value?.[0]?.endDate ? moment(value?.[0]?.endDate)?.format('D MMMM') : moment()?.format('D MMMM')}
            </Grid>
          </Grid>
        </Grid>
        <Grid className='usersInfoGraphic'>
          <Grid className='boxTitleTable'>
            <Grid className='leftTitleTable'>
              <Grid className='nameTable'>Reported users</Grid>
            </Grid>
            <Grid className='countTable'>Total: {fullStatisrics?.reports}</Grid>
          </Grid>
          <ResponsiveContainer width='100%' height='75%'>
            <LineChart width={200} height={100} data={reportInfo}>
              <CartesianGrid vertical={false} />
              <Line stroke='#2196F3' dataKey='createdCount' type='monotone' strokeWidth={2} />
              <Tooltip content={<CustomTooltip />} />
              <Label value='any' />
              <YAxis domain={[0, 40]} axisLine={false} orientation='right' />
            </LineChart>
          </ResponsiveContainer>
          <Grid className='dateTable'>
            <Grid className='dateStyle'>
              {value?.[0]?.startDate ? moment(value?.[0]?.startDate)?.format('D MMMM') : moment()?.format('D MMMM')}
            </Grid>
            <Grid className='dateStyle'>
              {value?.[0]?.endDate ? moment(value?.[0]?.endDate)?.format('D MMMM') : moment()?.format('D MMMM')}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid className='wrapperSelectDate'>
        <DateRangePicker value={value} setValue={setValue} />
        <Grid className='searchInput'>
          <Grid className='titleSearch'>
            Cities
          </Grid>
          <AutocompleteCity setSearchTown={setSearchTown} towns={towns} />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default All
